<div mat-dialog-title class="d-flex align-items-baseline justify-content-between">
  <h2 class="flex-grow-1" translate>NAVBAR.CHANGE_LANGUAGE</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon svgIcon="close_v2"></mat-icon>
  </button>
</div>
<mat-dialog-content class="container-max d-flex flex-column">
  <mat-radio-group [(ngModel)]="dialogData.currentLanguage">
    @for (lang of dialogData.languageMapping | keyvalue; track lang) {
      <mat-radio-button [value]="lang.key" color="primary">
        {{ lang.value }}
      </mat-radio-button>
    }
  </mat-radio-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="handleCancel()">
    <span translate>GENERIC.BUTTON_CANCEL</span>
  </button>
  <button mat-raised-button color="primary" (click)="handleSave()">
    <span translate>GENERIC.BUTTON_SAVE</span>
  </button>
</mat-dialog-actions>
